export enum AccountOriginEnum {
    WEB = 1,
    PDV = 2
}